// src
import { MINUTE, FETCHABLE_RESOURCES } from "config/constants";
import { peopleSuccess } from "actions/resources";
import { hydrateSlice } from "actions/system";
import { buildStorageAdapters } from "utils/storage";

const maxAge = 30 * MINUTE;
const saveDelay = 5000;
const [hydrate, save] = buildStorageAdapters("resources", { maxAge, saveDelay });

const DEFAULT_STATE = {
  courseIds: [],
  courseIndex: {},
  groupIds: [],
  groupIndex: {},
  peopleIds: [],
  peopleIndex: {},
  roomIds: [],
  roomIndex: {},
};

const updateIndex = (newItems, oldIndex) => {
  const appendIndex = {};
  newItems.forEach((item) => {
    appendIndex[item.id] = item;
    if (item.children) {
      item.children.forEach((child) => {
        appendIndex[child.id] = child;
      });
    }
  });
  const newIndex = { ...oldIndex, ...appendIndex };
  const newIds = Object.keys(newIndex);
  return { newIndex, newIds };
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  // success from FETCHABLE_RESOURCES
  for (const { success, singular, idsLabel } of FETCHABLE_RESOURCES) {
    if (type === success.toString()) {
      const indexLabel = `${singular}Index`; // for instance: groupIndex
      const index = state[indexLabel];
      const { newIndex, newIds } = updateIndex(payload, index);
      const newState = { ...state, [indexLabel]: newIndex, [idsLabel]: newIds };
      return save(newState);
    }
  }
  // other actions
  switch (type) {
    case peopleSuccess.toString(): {
      const index = state.peopleIndex;
      const { newIndex, newIds } = updateIndex(payload, index);
      return { ...state, peopleIndex: newIndex, peopleIds: newIds };
    }
    case hydrateSlice.toString(): {
      return hydrate(state, payload);
    }
    default:
      return state;
  }
};
